/**
 * パーツ種別
 */
const PARTS_STATUS = {
    // 選択肢ありメッセージ
    SELECT_MESSAGE: 0,
    // 応募フォーム
    APPLICATION_FORM: 1,
    // メッセージのみ
    MESSAGE: 2,
    // ロボ切替
    ROBO_CHANGE: 3,
    // 日程自動調整
    CALENDAR: 4,
    // 画像
    IMAGE: 5,
    // 自由入力
    FREE_INPUT: 6,
    // ファイルアップロード
    FAIL_UPLOAD: 7,
    // 履歴書フォーム
    RESUME_FORM: 8,
    // 最初から
    RESTART: 9,
    // メール送付
    MAIL_SEND: 10,
    // 欠番
    NO_ASSIGN: 11,
    // 条件分岐
    CONDITIONAL_BRANCH: 12,
    // チェックボックス
    CHACKBOX: 13,
    // 動画
    MOVIE: 14,
    // プルダウン選択
    PULL_DOWN_SELECT: 15,
    // SMS送付
    SMS_SEND: 16,
    // カルーセル選択
    CAROUSEL_SELECT: 17,
    // ファイルダウンロード
    FILE_DOWNLOAD: 18,
    // 回答出力
    ANSWER_OUTPUT: 19,
    // 検索
    SEARCH: 20,
    // PDFダウンロード
    PDF_DOWNLOAD: 21,
    // 付箋
    STICKY_NOTE: 22,
    // パーツセット
    PARTS_SET: 100,
}

export {
    PARTS_STATUS
}



// WEBPACK FOOTER //
// ./src/functions/robo/scenarioFunc.js